<template>
  <div class="footer-buttons">
      <IconButton v-for="button in buttons"
      :icon="button.icon"
      :key="button.label"
      :label="button.label"
      :colour="button.colour"
      variant="small"
      class="footer-button"
      @onClick="button.onClick"/>
  </div>
</template>
<script>
import { IconButton } from '@/framework';

// Pass buttons in this form:
export default {
  name: 'FooterButtons',
  props: {
    buttons: Array
  },
  components: {
    IconButton
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

</style>